import * as Diagram from "../../../../components/diagram";

export const WeakNextVisitList = {
  label: "衰弱訪視下次訪視清冊",
  key: "WeakNextVisitList",
  path: "ElderlyHealth/WeakNextVisitList",
  api: "TCS_V_FrailtyVisitNextVisitList",
  render: (options) => <Diagram.ElderlyHealth.WeakNextVisitList {...options} />,
  isRaw: true,
  isPage: true,
  filterColumns: [
    { key: "鄉鎮", label: "照護鄉鎮", type: "string" },
    { key: "案件狀態", type: "string" },
  ],
  dateRangeColumns: [{ label: "下次訪視日期", key: "下次訪視日期" }],
  columns: [
    {
      key: "身分證號",
      field: "身分證號",
      header: "身分證號",
    },
    {
      key: "個案名字",
      field: "個案名字",
      header: "個案名字",
    },
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "照護鄉鎮",
    },
    {
      key: "案件狀態",
      field: "案件狀態",
      header: "案件狀態",
    },
    {
      key: "訪視類別",
      field: "訪視類別",
      header: "訪視類別",
    },
    {
      key: "下次訪視日期",
      field: "下次訪視日期",
      header: "下次訪視日期",
    },
    {
      key: "建立人員",
      field: "建立人員",
      header: "建立人員",
    },
  ],
};
